import { createSvgIcon } from '@mui/material';

const BoxDimention = createSvgIcon(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.03 7.5L12 3L2.96997 7.5M21.03 7.5V16.5L12 21M21.03 7.5L12 12M12 21L2.96997 16.5V7.5M12 21V12M2.96997 7.5L12 12M16.51 5.25L7.48997 9.75"
      stroke="#9697AF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  'BoxDimention',
);

export default BoxDimention;
